module.exports = __webpack_public_path__ + "img/pocket-15_en.a809941.jpg";